(function($) { "use strict";

	// Section FAQ archive
	if( $('.section-toc').length ) {

		// @see https://css-tricks.com/sticky-table-of-contents-with-scrolling-active-states/
		// @see https://codepen.io/bramus/pen/ExaEqMJ
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const id = entry.target.getAttribute('id');
				//console.log(entry, entry.intersectionRatio);
				if (entry.intersectionRatio > 0) {
					document.querySelector(`nav li a[href="#${id}"]`).parentElement.classList.add('active');
				} else {
					document.querySelector(`nav li a[href="#${id}"]`).parentElement.classList.remove('active');
				}
			});
		});

		// Track all sections that have an `id` applied
		document.querySelectorAll('.section-toc article.block-toc a.anchor').forEach((article) => {
			observer.observe(article);
		});

	}

})(jQuery);






